import React from 'react';
import { ArrowRight } from 'lucide-react';
import { portfolioProjects } from '../mock';

const Portfolio = () => {
  return (
    <section id="portfolio" className="py-20 bg-[#F7F7F5]">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-14">
          <h3 className="text-[#D9A04A] tracking-[0.3em] text-sm font-semibold mb-3">WEB DESIGN &amp; DEVELOPMENT PROJECTS</h3>
          <div className="flex items-center justify-center gap-4">
            <span className="w-12 h-px bg-[#2C5F66]/30" />
            <h2 className="text-[#2C5F66] text-3xl md:text-4xl font-extrabold">Our Featured Work</h2>
            <span className="w-12 h-px bg-[#2C5F66]/30" />
          </div>
        </div>

        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-7">
          {portfolioProjects.map((proj) => (
            <article
              key={proj.name}
              className="group bg-white rounded-lg overflow-hidden shadow-md hover:shadow-2xl transition-all duration-300 hover:-translate-y-1"
            >
              <div className="overflow-hidden h-48">
                <img
                  src={proj.image}
                  alt={proj.name}
                  className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-110"
                />
              </div>
              <div className="p-6">
                <span className="text-[#D9A04A] text-xs font-semibold tracking-wider uppercase">{proj.tag}</span>
                <h4 className="mt-2 text-[#2C5F66] text-xl font-bold leading-tight group-hover:text-[#D9A04A] transition-colors">
                  {proj.name}
                </h4>
                <p className="mt-3 text-gray-600 text-sm leading-relaxed line-clamp-3">{proj.description}</p>
                <a href="#" className="mt-4 inline-flex items-center gap-1 text-[#2C5F66] font-semibold text-sm hover:text-[#D9A04A] transition-colors">
                  Read More <ArrowRight size={14} />
                </a>
              </div>
            </article>
          ))}
        </div>

        <div className="text-center mt-12">
          <a
            href="#"
            className="inline-block bg-[#2C5F66] hover:bg-[#244e54] text-white font-semibold px-8 py-3 rounded-md transition-colors"
          >
            View Additional Projects
          </a>
        </div>
      </div>
    </section>
  );
};

export default Portfolio;
